import { API_URL_SOCKET } from "../models/api-base";
import {
    apiURL_create_moderators,
    apiURL_delete_moderator,
    apiURL_get_chat_live,
    apiURL_get_chat_live_by_date
} from "../models/api-urls";

import fetchService from "../modules/APIService";

class Service extends fetchService {
  constructor() {
    super(API_URL_SOCKET);
  }

  getAllComments = async () => {
    try {
      const response = await this.get(apiURL_get_chat_live);
      return response?.data ?? response ?? [];
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  getDateComments = async (date) => {
    try {
      const encodedDate = encodeURIComponent(date);
      const response = await this.get(`${apiURL_get_chat_live_by_date}/${encodedDate}`);
      return response?.data ?? response ?? null;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  addModerator = async (arrOfChannelsProps) => {
    try {
      const response = await this.post(
        apiURL_create_moderators,
        arrOfChannelsProps
      );
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  deleteModerator = async (arrOfChannelsProps) => {
    try {
      const response = await this.put(
        apiURL_delete_moderator,
        arrOfChannelsProps
      );
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
}

const ChatService = new Service();

export default ChatService;
